import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55b07c32&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=55b07c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b07c32",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/chooseStore/index.vue
// module id = null
// module chunks = 